<template>
<div id="notification-card" class="card shadow-sm">
	<loading :active.sync="notificationLoading" 
        :can-cancel="true"
        :is-full-page="false"></loading>
	<div class="card-header">
		<h3 class="notification-title">Notification</h3>
	</div>
	<div class="card-body">  
		<div><!-- class="notification-select"--> <!--select condition START-->
			<b-form inline>
				<!--img src="../assets/images/filter.svg" alt="filter" class="filter-icon mr-2 ml-4"-->
				<label for="level-list" class=" mr-2 ml-2">Level</label>
				<b-form-select id="level-list"  v-model="selectedLevel" :options="levelOptions" size="sm" class="mr-4"></b-form-select>
				<label for="bot-list" class=" mr-2">그룹</label>
				<b-form-select id="bot-list"  v-model="selectedGroup" :options="groupOptions" size="sm" class="mr-4"></b-form-select>
				<label for="bot-list" class=" mr-2">Peon</label>
				<b-form-select id="bot-list"  v-model="selectedPeon" :options="peonOptions" size="sm" class="mr-4"></b-form-select>
				<label for="duration">기간</label>
                <b-form-input type="date" size="sm" v-model="from" :key="fromKey"></b-form-input> ~ 
				<b-form-input type="date" size="sm" v-model="to" :key="toKey"></b-form-input>
				<button type="button" class="ml-5 btn btn-blue btn-sm" @click="reloadNotificationList()">Reload</button>
				
			</b-form>
		</div>  <!--select condition END-->

		<b-table id="notification-table" class="card-body table table-hover table-bordered table-striped shadow-sm"  
			:items="notificationList"
			:fields="fieldsx"
			thead-class="text-center notification-header">

			<template #cell(status)="row" > <!--상태 확인 버튼 --> 		
				<button v-if="row.item.level !== 'normal' && row.value === 'confirmed'"  class="btn btn-gray btn-sm" disabled>Confirmed</button>
				<!-- <button v-else-if="row.data.level !== 'normal'" class="btn btn-notification btn-sm" v-on:click="confirm(row.index)">Confirm</button> -->
				<button v-else-if="row.item.level !== 'normal'" class="btn btn-notification btn-sm" v-on:click="showConfirm(row.index)">Confirm</button>
			</template>
	
			<template #cell(level)="data"  > <!--level 색 표시-->
				<div v-if="data.value === 'normal'" class="text-normal">
					<span class="dot-normal"></span> {{ data.value }}
				</div>
				<div  v-else-if="data.value === 'major'" class="text-major">
					<span class="dot-major"></span> {{ data.value }}
				</div>
				<div  v-else-if="data.value === 'minor'" class="text-minor">
					<span class="dot-minor"></span> {{ data.value }}
				</div>
				<div  v-else class="text-critical">
					<span class="dot-critical"></span> {{ data.value }}
				</div>
			</template>
	
			<template #cell(message)="row"  >		
				<div v-bind:style="row.item.uuid != null && row.item.uuid != '' ? {cursor: 'pointer'}: {}" v-on:click="triggerProcessEvent(row.item.deviceId, row.item.uuid)">
					{{ row.item.message }}
					<div v-if="row.item.cause != null" class="btn-gray rounded pl-2">
						{{ row.item.cause }}
					</div>
				</div>
			</template>
			
		</b-table>

		<div>
			<button class="btn btn-view-more" v-on:click="seeMore()" :disabled="notificationList.length == totalNotification">더보기 ({{ notificationList.length }} / {{ totalNotification }})</button>
		</div>
	</div><!--card body end-->

	<b-modal size="lg" ref="modalConfirmAlarm"  header-class="detail-header" title="Confirm this alarm" @ok="confirmAlarm"> <!-- size = xl, lg, sm -->
		<loading :active.sync="confirmLoading" 
			:can-cancel="true"
			:is-full-page="false"></loading>
			<table class="table table-striped table-bordered table-hover shadow-sm mt-2">
			<thead class="script-header" >
					<tr class="text-center">
						<th>Level</th>
						<th>Peon</th>
						<th>Message</th>
					</tr>
			</thead>
			<tbody>
				<tr>
					<td>
						<!--level 색 표시-->
						<div v-if="selectedAlarm.level === 'normal'" class="text-normal">
							<span class="dot-normal"></span> {{ selectedAlarm.level }}
						</div>
						<div  v-else-if="selectedAlarm.level === 'major'" class="text-major">
							<span class="dot-major"></span> {{ selectedAlarm.level }}
						</div>
						<div  v-else-if="selectedAlarm.level === 'minor'" class="text-minor">
							<span class="dot-minor"></span> {{ selectedAlarm.level }}
						</div>
						<div  v-else class="text-critical">
							<span class="dot-critical"></span> {{ selectedAlarm.level }}
						</div>
					</td>
					<td>{{ selectedAlarm.alias }}</td>
					<td>{{ selectedAlarm.message }}</td>
				</tr>
				<tr>
					<td colspan="3"><input type="text" class="form-control" placeholder='Type the reason of this alarm.' v-model="cause" /></td>
				</tr>
			</tbody>
		</table>
	</b-modal>

	<!-- alert popup -->
	<b-modal id="messageModal" header-class="fail-header" title="Message" ok-only ok-variant="secondary" ok-title="Close">
        <p class="my-4 text-center">{{ msgContent }}</p>
    </b-modal>
</div><!--//notification card end-->
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
	name: 'Notification',
	components: {
        Loading
    },
	data() {
		return {
			/* for b-table style START */
			fieldsx: [
				{
					key: 'status',
					sortable: false,
					label: 'Status',
					// style: '{width: 500px}'
				},
				{
					key: 'level',
					sortable: false,
					label: 'Level', 
					tdClass: 'level-style'
				},
				{
					key: 'alias',
					sortable: false,
					label: 'Bot Alias', 
					tdClass: 'bot-alias-style'
				},
				{
					key: 'timestamp',
					sortable: false,
					label: 'Timestamp'
				},
				{
					key: 'message',
					sortable: false,
					label: 'Messages'
				}
			],

			/* for b-table style END*/

			/* for select option START */
			selectedLevel: '', 
			levelOptions: [
				//{ value: 'all', text: 'Please select a level' }, 
				// { value: 'null', text: 'Please select a level' }, 
				{ value: '', text: '전체' },
				{ value: 'alive', text: '미확인 알람' },
				{ value: 'alarm', text: '알람' },
				{ value: 'normal', text: '일반' }
				// { value: 'major', text: 'major' }, 
				// { value: 'minor', text: 'minor' }, 
				// { value: 'critical', text: 'critical' }
			], 
			
			selectedPeon: '',
			selectedGroup: '',
			from:'',
			to:'',
			fromKey: 0,
    		toKey: 0,
			previousFrom: '',
			previousTo: '',

			selectedAlarm: {},
			cause: '',

			total: 0,
			normal: 0,
			alarm: 0,
			alive: 0,

			// notificationList: [],
			notificationLoading: false,  // Notification에서 보여주는 로딩바
            confirmLoading: false,  // alarm confirm 할 때 보여주는 로딩바
            msgStatus: '',  // alert popup 의 status 인데 사용하진 않고, 아래 content는 보여줌
            msgContent: '',

            notificationTimer: null,
			reloadQueue: Promise.resolve(),
            // totalNotification: 0,  // 이건 store.js에서 호출한 retreiveNotificationList의 total을 복사해 두고 있다가 달라지면 여기서도 retrieveNotificationList를 호출하도록 함
		}
	},
	computed: {
		groupOptions(){
			return this.$store.state.groupOptions;
		},
		peonOptions() {
			var options = [
				{ value: '', text: '전체' }
			];

			this.$store.state.peonList2.forEach((item) => {
				if((this.selectedGroup == '' || this.selectedGroup == item.deviceGroupId )&& (!options.some(list => list.value === item.deviceId))){
					options.push({
						value: item.deviceId, text: item.alias
					});
				}
			});

			if(!options.some(list => list.value === this.selectedPeon)){
				this.selectedPeon = '';
			}

			return options;
		},
		notificationList() {
			return this.$store.getters.getNotificationList;
		},
		totalNotification() {
			switch (this.selectedLevel) {
				case 'alive': return this.$store.getters.getTotalUnconfirmedAlarm;
				case 'alarm': return this.$store.getters.getTotalAlarm;
				case 'normal': return this.$store.getters.getTotalNormalNotification;
				default: return this.$store.getters.getTotalNotification;
			}
  		},
	},
	watch:{
		from() {
			if (!this.validateFromDates()) {
				this.from = this.previousFrom;
				this.fromKey++;
			} else {
				this.previousFrom = this.from;
			}
		},
		to() {
			if (!this.validateToDates()) {
				this.to = this.previousTo;
				this.toKey++;
			} else {
				this.previousTo = this.to;
			}
		}
	},
	methods: {
		validateToDates() {
			if (this.from && this.to && new Date(this.to) < new Date(this.from)) {
				this.showMessage('Message','조회종료일은 조회시작일보다 이후여야 합니다.');
				return false;
			}
			return true;
		},

		validateFromDates() {
			if (this.from && this.to && new Date(this.from) > new Date(this.to)) {
				this.showMessage('Message','조회시작일은 조회종료일보다 이전이어야 합니다.');
				return false;
			}
			return true;
		},
        triggerProcessEvent(deviceId, uuid) {
        	// 여긴 uuid가 없는 애들이 많기 때문에 미리 조건 검사함
        	if (uuid == null || uuid == '') {
        		return;
        	}

            this.$emit('triggerProcessEvent', deviceId, uuid);
        },
        showMessage(status, message) {
			this.msgStatus = status;
			this.msgContent = message;

			this.$bvModal.show('messageModal');
		},
		totalByCondition() {
			if (this.selectedLevel == 'normal') {
				return this.normal;
			} else if (this.selectedLevel == 'alarm') {
				return this.alarm;
			} else if (this.selectedLevel == 'alive') {
				return this.alive;
			} else {
				return this.total;
			}
		},
		reloadNotificationList() {
			let params = {};
			if(this.selectedGroup) params.groupId = this.selectedGroup;
			if(this.selectedPeon) params.deviceId = this.selectedPeon;
			if(this.selectedLevel) params.level = this.selectedLevel;
			if(this.from) params.from = this.from;
			if(this.to) params.to = this.to;

			this.$emit('update', { property: 'selectedLevel', value: this.selectedLevel });
			this.$emit('update', { property: 'selectedPeon', value: this.selectedPeon });
			this.$emit('update', { property: 'selectedGroup', value: this.selectedGroup });
			this.$emit('update', { property: 'selectedFrom', value: this.from });
			this.$emit('update', { property: 'selectedTo', value: this.to });
			
			this.reloadQueue = this.reloadQueue.then(async () => {
				this.notificationLoading = true;
				await this.$store.commit('clearNotificationList');  // 첫 번째 작업
				await this.$store.dispatch('retrieveNotificationList', params);  // 두 번째 작업

				this.notificationLoading = false;
			});


			// this.$store.dispatch('retrieveNotificationList', param);
		// 	this.notificationList = [];

		// 	this.retrieveNotificationList(this.selectedPeon, this.selectedLevel);
		},
		// retrieveNotificationList(deviceId, level, serial) {
		// 	var params = {};

		// 	if (deviceId != null && deviceId != '') {
		// 		params.deviceId = deviceId;
		// 	}

		// 	if (level != null || level != '') {
		// 		params.level = level;
		// 	}

		// 	if (serial != undefined) {
		// 		params.serial = serial;
		// 	}

		// 	window.axios.post('peon/retrieveNotificationList', params, {
		// 		headers: {
		// 		'Accept': 'application/json',
		// 		'Authorization': window.accessToken()
		// 		}
		// 	}).then(response => {  // 이 response는 WorkMan이 status를 0으로 보낸 경우만 해당됨 (나머지 status가 0이 아닌 논리 오류는 main.js에서 이미 error로 보내도록 되어 있음)
		// 		// notificationList의 serial 범위 밖이면 추가, 아니면 중복으로 보고 무시
		// 		var minSerial = Number.MAX_SAFE_INTEGER, maxSerial = Number.MIN_SAFE_INTEGER;
		// 		if (this.notificationList.length > 0) {
		// 			maxSerial = this.notificationList[0].serial;
		// 			minSerial = this.notificationList[this.notificationList.length - 1].serial;
		// 		}

		// 		response.data.body.list.forEach((item) => {
		// 		if (item.serial < minSerial || item.serial > maxSerial) {
		// 			this.notificationList.push(item);
		// 		}
		// 	});

		// 	this.notificationList.sort((a, b) => {
		// 		return a.serial < b.serial ? 1 : a.serial > b.serial ? -1 : 0;
		// 	});

		// 		this.alive = response.data.body.alive;
		// 		this.alarm = response.data.body.alarm;
		// 		this.normal = response.data.body.normal;
		// 		this.total = response.data.body.total;
		// 	}).catch(error => {
		// 	if (error.status != 401) {
		// 		this.showMessage(error.status == 200 ? error.code : error.status, error.message);
		// 	}
		// 	}).finally(() => {
		// 		// 로딩바가 없어서 할 일이 여기선 없네...
		// 	});

		// },
		showConfirm: function(index) {
			this.selectedAlarm = {
				'tenantId': this.notificationList[index].tenantId, 
				'deviceId': this.notificationList[index].deviceId, 
				'serial': this.notificationList[index].serial,
				'alias': this.notificationList[index].alias,
				'timestamp': this.notificationList[index].timestamp,
				'level': this.notificationList[index].level,
				'message': this.notificationList[index].message
			};

			this.cause = '';

			this.$refs['modalConfirmAlarm'].show();
		},
		// confirm
		confirmAlarm(bvModalEvt) {
			if (this.cause.trim() == '') {
               this.showMessage(null, '이유를 입력하세요.');

				bvModalEvt.preventDefault();

				return;
			}

			this.confirmLoading = true;
			
			this.$store.dispatch('confirmNotification', 
				{
					'deviceId':this.selectedAlarm.deviceId, 
					'serial': this.selectedAlarm.serial,
					'cause': this.cause
				}
			).then(() => {
				var index = this.notificationList.findIndex((item) => { return item.serial == this.selectedAlarm.serial });
				if (index >= 0) {
					this.notificationList[index].status = "confirmed";
					this.notificationList[index].cause = this.cause.trim();
				}
				
                this.showMessage(null, "알람이 확인되었습니다.");
			}).catch(error => {
                if (error.status != 401) {
					this.showMessage(error.status == 200 ? error.code : error.status, error.message);

					// 아래는 왜 팝업이 닫히지? 위에는 안닫히는데..
					// bvModalEvt.preventDefault();
					// bvModelEvt.returnValue = false;

					// return false;
				}
			}).finally(() => {
				this.confirmLoading = false;
			});
		},
		seeMore() {
			this.notificationLoading = true;
			let params = {
				serial: this.notificationList[this.notificationList.length - 1].serial
			};
			if(this.selectedPeon) params.deviceId = this.selectedPeon;
			if(this.selectedLevel) params.level = this.selectedLevel;
			if(this.from) params.from = this.from;
			if(this.to) params.to = this.to;
			this.$store.dispatch('retrieveNotificationList', params);
			this.notificationLoading = false;
			// this.retrieveNotificationList(this.selectedPeon, this.selectedLevel, this.notificationList[this.notificationList.length - 1].serial);
		}
	},
	mounted() {
		const now = new Date();

		const today = now.toLocaleString('sv-SE', { timeZone: 'Asia/Seoul' }).replace(' ', 'T').slice(0, 10);

		this.selectedPeon = '';
		this.selectedLevel = '';
		this.selectedGroup = '';

		this.from = today;
		this.to = today;
		this.previousFrom = this.from;
		this.previousTo = this.to;

		this.$emit('update', { property: 'selectedLevel', value: this.selectedLevel });
		this.$emit('update', { property: 'selectedPeon', value: this.selectedPeon });
		this.$emit('update', { property: 'selectedGroup', value: this.selectedGroup });
		this.$emit('update', { property: 'selectedFrom', value: this.from });
		this.$emit('update', { property: 'selectedTo', value: this.to });
		
		this.reloadNotificationList();

		
		
	}
	// created() {
	// 	this.$store.dispatch('retrieveNotificationList');
	// }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

#level-list, #bot-list {
	margin-top : 5px;
	margin-bottom: 5px;
}
#notification-card input.form-control {
	height: calc(1.5em + 0.5rem + 2px) !important;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    padding-left: 0.5rem;
    font-size: 0.875rem;
	background-color: white;
	border: 1px solid #ced4da;
    border-radius: 0.25rem !important;
	margin: 0 0.5rem 5px 0.5rem;
}
</style>
